import { signal } from '@preact/signals-react';

// `requestId` ties the outcome to one BOOK press, so a late result can never act
// on a later caller (or a reopened one). `cancelled`: the saga was cancelled while
// the request was in flight — the server may still have created the appointment.
export type ICallerBookingOutcome = { requestId: string; ok: boolean; cancelled?: boolean };

// Result of a quick booking sent for a caller, written by the quickBooking saga.
// Lets the caller composer clear the booked customer only after the server
// accepted the booking, and keep the form when it failed. A signal rather than a
// redux callback: actions must stay serializable.
export const callerBookingOutcome = signal<ICallerBookingOutcome | null>(null);
